import { DepositAccountType } from '@/api/v1/organization/deposit-accounts/getDepositAccountsApi';
import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';

export const getDepositAccountApi = async (depositAccountId: string): Promise<ApiResponseType<DepositAccountType>> => {
  const uri = `/organization/deposit-accounts/${depositAccountId}/`;

  return authApiService.GET(uri);
};
